import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import Grid from "../../elements/Grid";
import Link from "../../elements/Link";
import Standfirst from "../../fragments/Standfirst";
import Profile from "./components/Profile";
import { LinkTypes } from "../../elements/Link/LinkTypes";

var ProfileGallery = function ProfileGallery(_ref) {
  var children = _ref.children,
      introduction = _ref.introduction,
      linkHref = _ref.linkHref,
      linkTitle = _ref.linkTitle,
      verticalAtDesktop = _ref.verticalAtDesktop;
  var getClassName = getClassNameFactory(ProfileGallery.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: verticalAtDesktop ? "verticalAtDesktop" : ""
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    variant: "1/3,2/3"
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "intro"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "standfirst"
    })
  }, /*#__PURE__*/React.createElement(Standfirst, null, introduction)), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "link"
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: linkHref,
    type: LinkTypes.PRIMARY
  }, linkTitle)))), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "profiles"
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "profilesInner"
    })
  }, children)))));
};

ProfileGallery.displayName = "ProfileGallery";
ProfileGallery.defaultProps = {
  verticalAtDesktop: true
};
ProfileGallery.Profile = Profile;
export default ProfileGallery;